<base-index-page
  [config]="baseIndexPageConfig"
  [service]="deleteService"
  [idKey]="'vltId'">

  <regulator-context-box [items]="contextItems" (back)="goBack()" />

</base-index-page>
